<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-动态-修改
    -->
    <el-dialog
    title="修改动态"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">

        <el-form-item label="动态名称" prop="name"><el-input v-model="form.name" placeholder="请输入动态名称" class="max-w460"></el-input></el-form-item>


<!--      <el-form-item label="动态bannar：" prop="model.image">-->
<!--      <div class="draggable-list">-->
<!--        <draggable class="wrapper" v-model="form.bannar">-->
<!--          <transition-group>-->
<!--            <div v-for="(item, index) in form.bannar" :key="item.file_path">-->
<!--              <div class="item">-->
<!--                <img v-img-url="item.file_path" alt="file_path"/>-->
<!--                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>-->
<!--              </div>-->
<!--            </div>-->
<!--          </transition-group>-->
<!--        </draggable>-->
<!--        <div class="item img-select" @click="openProductUpload('bannar')">-->
<!--          <i class="el-icon-plus"></i>-->
<!--        </div>-->
<!--      </div>-->
<!--    </el-form-item>-->
<!-- 动态分类 - -->
       <el-form-item label="动态分类" prop="categorya">
         <el-select v-model="form.categorya" placeholder="请选择动态分类" class="max-w460" clearable>
           <el-option
             v-for="item in categoryOptions"
             :key="item.value"
             :label="item.label"
             :value="item.value">
           </el-option>
         </el-select>
       </el-form-item>

      <el-form-item label="动态图片：" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.image">
          <transition-group>
            <div v-for="(item, index) in form.image" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('album')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>
    <el-form-item label="动态介绍">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item> 
<!-- <el-form-item label="动态简介" prop="intro">
  <el-input 
    type="textarea" 
    v-model="form.intro" 
    placeholder="请输入动态简介" 
    :rows="4"
    class="max-w460">
  </el-input>
</el-form-item> -->
       

      <el-form-item label="排序" prop="sort"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>


      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
      </div>
</el-dialog>

</template>

<script>
import DynamicsApi from '@/api/dynamics.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     draggable,
     Uediter
  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        // categorya:{
        //   name:""
        // },
        image:[],
        sort:50,
        intro:"",
        bannar:[],
        categorya: ''  // 动态分类字段
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入动态名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      // 分类选项
      categoryOptions: [
        { value: 'company_dynamics', label: '公司动态' },
        { value: 'bid_winning', label: '中标项目' },
        { value: 'project_dynamics', label: '项目动态' }
      ]
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","dynamics_id"],
  methods: {

    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;

      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      DynamicsApi.detail({dynamics_id: self.dynamics_id}, true).then(res => {
        self.form = res.data;
        self.ueditor.text = self.form.intro;
        self.isImg = true
        self.loading = false;

        // 确保 bannar 是数组类型
        if(!self.form.bannar){
          self.form.bannar = [];
        } else if (typeof self.form.bannar === 'string') {
          try {
            self.form.bannar = JSON.parse(self.form.bannar);
          } catch(e) {
            self.form.bannar = [];
          }
        }

        // 确保 image 是数组类型
        if(!self.form.image){
          self.form.image = [];
        } else if (typeof self.form.image === 'string') {
          try {
            self.form.image = JSON.parse(self.form.image);
          } catch(e) {
            self.form.image = [];
          }
        }

        // 如果后端返回的分类值是中文，可以在这里做映射转换
        // 例如：后端返回 "公司动态" 转换为 "company_dynamics"
        const categoryMap = {
          '公司动态': 'company_dynamics',
          '中标项目': 'bid_winning',
          '项目动态': 'project_dynamics'
        };
        if (self.form.categorya && categoryMap[self.form.categorya]) {
          self.form.categorya = categoryMap[self.form.categorya];
        }
      })
      .catch(error => {});
    },
onSubmit() {
  let self = this;
  let form = JSON.parse(JSON.stringify(self.form)); // 深拷贝，避免影响原数据

  form.dynamics_id = self.dynamics_id;
 form.intro = this.$refs.ue.getUEContent();
  // 将英文代码转换为中文存储到数据库
  const categoryTextMap = {
    'company_dynamics': '公司动态',
    'bid_winning': '中标项目',
    'project_dynamics': '项目动态'
  };
  form.categorya = categoryTextMap[form.categorya] || form.categorya;

  self.$refs.form.validate(valid => {
    if (valid) {
      self.loading = true;
      DynamicsApi.edit(form, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: data.msg,
            type: 'success'
          });
          self.dialogFormVisible("error")
        })
        .catch(error => {
          self.loading = false;
        });
    }
  });
},

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },


    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }

      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }

    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/dynamics/index/part/edit.vue